import { Component, Input, OnChanges, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { KamService } from '@app/shared/services/kam.service';
import { isNil } from 'lodash';
import { environment } from '@env/environment';
import { AzureBlobStorageService } from '@app/shared/services/api/azure-blob-storage.service';
import { User } from '@app/shared/models/user';
import { SafeUrl } from '@angular/platform-browser';
import { catchError, first } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { KamUser } from '@app/contact-page/models/kam-user';

@Component({
  selector: 'app-kam-contact-info',
  templateUrl: './kam-contact-info.component.html',
  styleUrls: ['./kam-contact-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KamContactInfoComponent implements OnChanges {
  @Input() municipalityId!: string;
  @Output() kamInitialized: EventEmitter<KamUser> = new EventEmitter<KamUser>();
  public kamUser: KamUser = {} as KamUser;
  public imageSrc: SafeUrl | null = '';
  public isImageLoading = true;
  public senderEmail: string;
  public isNotSuwag: boolean;

  constructor(private azureBlob: AzureBlobStorageService, private kamService: KamService) {
    this.senderEmail = environment.companyGroupEmail;
    this.isNotSuwag = environment.tenant !== 'swg';
  }

  public ngOnChanges(): void {
    if (this.municipalityId) {
      this.kamService
        .getByMunicipalityIdDirect(this.municipalityId)
        .pipe(catchError(() => of(null)))
        .subscribe((m: User | null) => {
          if (!isNil(m) && !isNil(m.email) && m.email.length > 0) {
            this.kamUser = {
              email: m.email,
              firstName: m.firstname,
              lastName: m.lastname,
              textT: m.telefon,
              textF: m.fax,
              company: m.company,
              mobile: m.mobil,
              fax: m.fax,
              imageSrc: m.imageName,
            };
          } else {
            this.kamUser = {
              email: environment.companyGroupEmail,
              firstName: environment.companyGroupEmail,
              lastName: '',
              textT: '',
              textF: '',
              company: '',
              mobile: '',
              fax: '',
              imageSrc: null,
            };
          }

          if (this.kamUser.imageSrc) {
            this.azureBlob
              .getBlobImageSafeUrl(`${environment.tenant}/assets/images/users/${this.kamUser.imageSrc}`)
              .pipe(
                catchError((err: HttpErrorResponse) => {
                  this.imageSrc = null;
                  this.isImageLoading = false;
                  return throwError(() => err);
                }),
                first()
              )
              .subscribe((result: SafeUrl) => {
                this.imageSrc = result;
                this.isImageLoading = false;
              });
          } else {
            this.imageSrc = null;
            this.isImageLoading = false;
          }

          this.kamInitialized.emit(this.kamUser);
        });
    }
  }

  public mailer(email: string | null = null): void {
    const mail = email || this.senderEmail;
    window.location.href = `mailto:${mail}`;
  }
}
